/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { MsoDefaultBrandingUiBundleServiceRepositoryImpl } from '../impls/MsoDefaultBrandingUiBundleServiceRepositoryImpl';
import { IMsoDefaultBrandingUiBundleServiceRepository } from '../interfaces/IMsoDefaultBrandingUiBundleServiceRepository';

export class MsoDefaultBrandingUiBundleService
    implements IMsoDefaultBrandingUiBundleServiceRepository
{
    private oMsoDefaultBrandingUIServiceRepository: MsoDefaultBrandingUiBundleServiceRepositoryImpl;

    public constructor() {
        this.oMsoDefaultBrandingUIServiceRepository =
            new MsoDefaultBrandingUiBundleServiceRepositoryImpl();
    }

    public static initialize(baseUrl: string, whiny?: boolean) {
        MsoDefaultBrandingUiBundleServiceRepositoryImpl.initialize(baseUrl, whiny);
    }

    public async fetchMsoDefaultBrandingUiInfo(): Promise<void> {
        return this.oMsoDefaultBrandingUIServiceRepository.fetchMsoDefaultBrandingUiInfo();
    }

    public getBrandingUiInfoForKey(key: string): any {
        return this.oMsoDefaultBrandingUIServiceRepository.getBrandingUiInfoForKey(key);
    }
}
